import React from "react";

const VideoList = ({ files, onDelete }) => {
  return (
    <div className="media-gallery">
      <h3>🎥 Videos</h3>
      <div className="media-grid">
        {files.length === 0 ? (
          <p>No videos found.</p>
        ) : (
          files.map(file => (
            <div key={file.id} className="media-item">
              <video width="100%" controls>
                <source src={file.url} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <p>{file.name}</p>
              <button onClick={() => onDelete(file.name)}>🗑</button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default VideoList;
